import Header from "./header";
import { useDispatch, useSelector } from "react-redux";
import Menu from "./menu";
import { useEffect, useState } from "react";
import Loading from "components/Loading";
import { useLocation, useNavigate } from "react-router-dom";
import ShowMassage from "components/ShowMassage";
import DeleteMassage from "components/DeleteMassage";
import CreateServices from "containers/servicesCall/create";
import Details from "containers/servicesCall/details";
import { setSelectedLang } from "store/userSettingsSlice";
import { getFromLocalStorage } from "config/functions";
import { LANGUAGES_LIST } from "config/const";
import MeterReader from "components/MeterReader";
import QRScanner from "components/QRScanner";
import Permission from "./Permission";
import {
  Box,
  Fade,
  Stack,
  Toolbar,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import ChangeBizLoading from "components/ChangeBizLoading";
import Support from "components/support";
import ShowNotification from "components/ShowNotification";
import ValidationDialog from "components/ValidationDialog";

const Layout = ({ children }) => {
  const theme = useTheme();
  const dispatch = useDispatch()
  const navigate = useNavigate();
  const location = useLocation();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isLogin = useSelector((state) => state?.userSettings?.isLogin);
  const hideFloatingNotifications = useSelector((state) => state.userSettings?.user?.hideFloatingNotifications);
  const openQRScanner = useSelector((state) => state.userSettings?.qRScanner?.open);
  const openMeterReader = useSelector((state) => state.userSettings?.meterReader?.open);
  const openCreateServices = useSelector((state) => state?.servicesCall.openCreateServices);
  const openSupport = useSelector((state) => state.sys?.openSupport);

  const [openMenu, setOpenMenu] = useState(false);
  const [openPermission, setOpenPermission] = useState(false);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        navigate(-1);
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [navigate]);

  useEffect(() => {
    const localUser = getFromLocalStorage("user");
    const selectedLang = getFromLocalStorage("selectedLang");

    if (localUser?.lang)
      dispatch(setSelectedLang(localUser?.lang));
    else if (selectedLang)
      dispatch(setSelectedLang(selectedLang));
    else
      dispatch(setSelectedLang(LANGUAGES_LIST[0]));
  }, [])

  useEffect(() => {
    const locPage =
      location?.pathname.includes("signup") ||
      location?.pathname.includes("Login") ||
      location?.pathname.includes("loginEmp");

    if (isLogin) {
      if (!isMobile) setOpenMenu(true);
    }

    if (!isLogin && !locPage) {
      navigate("/Login");
    }
  }, [isLogin]);

  return (
    <Stack height={{ xs: "100svh", md: "100vh" }} bgcolor="bg.main">
      {isLogin
        ? <Fade in={isLogin}>
          <Box sx={{ display: "flex", overflow: "hidden", height: "100%" }}>

            <Header setOpenMenu={setOpenMenu} openMenu={openMenu} />
            <Menu setOpenMenu={setOpenMenu} openMenu={openMenu} />

            <Stack
              height="100%"
              sx={{ overflowY: "scroll", scrollbarWidth: "none" }}
              component="main"
              flexGrow={1}
            >

              <Toolbar />

              {children}

            </Stack>
          </Box>
        </Fade>
        : children
      }

      <Loading />
      <ChangeBizLoading />
      <DeleteMassage />
      <ValidationDialog />
      <ShowMassage />
      <Details />

      <Permission open={openPermission} setOpen={setOpenPermission} />

      {!isMobile && !hideFloatingNotifications ? <ShowNotification /> : null}
      {openQRScanner ? <QRScanner /> : null}
      {openMeterReader ? <MeterReader /> : null}
      {openCreateServices ? <CreateServices /> : null}
      {openSupport ? <Support /> : null}
    </Stack>
  );
};
export default Layout;
